module.exports = __webpack_public_path__ + "google-plus.png?790b541077a3e088817661be31e6a9e3";